const regex = {
  // ZIP: /\b\d{5}\b/g,
  ZIP: '',
  PHONE: /^[0-9]{10}$/,
  PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
};

export default regex;
